import {Inject, Injectable} from "@angular/core";
import {ApiResourceLocation, ResourceService, SOFTLINE_SERVICE_HTTP} from "@softline/core";
import {Material, Produktkalkulation} from "../types/produktkalkulation";
import {Observable} from "rxjs";
import {
  SOFTLINE_API_PRODUKTKALKULATION_ARTIKELEINGABEN,
  SOFTLINE_API_PRODUKTKALKULATION_NEURECHNEN,
  SOFTLINE_API_PRODUKTKALKULATION_SPEICHERN,
  SOFTLINE_API_PRODUKTKALKULATION_SPEICHERN_STUECKLISTE
} from "../produktkalkulation.api";

@Injectable()
export class ProduktkalkulationService {
  constructor(@Inject(SOFTLINE_SERVICE_HTTP) private service: ResourceService<ApiResourceLocation>) {
  }

  recalculate(value: Produktkalkulation): Observable<Produktkalkulation> {
    return this.service.create<Produktkalkulation, Produktkalkulation>(
      {path: SOFTLINE_API_PRODUKTKALKULATION_NEURECHNEN}, value
    )
  }

  getTemplateValues(body: { idartstamm: number, menge: number, gewicht: number | null; mengeCt: number | null }): Observable<Material> {
    return this.service.create<{ idartstamm: number, menge: number }, Material>(
      { path: SOFTLINE_API_PRODUKTKALKULATION_ARTIKELEINGABEN },
      body,
    )
  }

  save(value: Produktkalkulation): Observable<Produktkalkulation> {
    return this.service.create<Produktkalkulation, Produktkalkulation>(
      {path: SOFTLINE_API_PRODUKTKALKULATION_SPEICHERN}, value
    )
  }

  saveStueckliste(value: Produktkalkulation): Observable<Produktkalkulation> {
    return this.service.create<Produktkalkulation, Produktkalkulation>(
      { path: SOFTLINE_API_PRODUKTKALKULATION_SPEICHERN_STUECKLISTE },
      value
    )
  }
}
